module.exports = __webpack_public_path__ + "img/file-upload.bb7f446b.svg";